<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" id="content_screen">
    <div class="p-3 flex content-main">
      <div class="custom-full">
        <Nav activeTab="BusinessSettings"></Nav>
        <div class="bg-[#2B2C32] rounded-lg max-w-full mb-[80px]">

          <template v-if="vg_selectedLocation.id">
            <div class="self-stretch self-stretch p-4 rounded-md inline-flex flex-col justify-start items-start gap-4">
              <div data-qty-btn="true" data-style="Collapse" class="self-stretch py-4 rounded-md inline-flex justify-start items-center gap-6">
                <div class="flex-1 flex justify-start items-center gap-2">
                  <div class="flex-1 justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight">Business settings</div>
                </div>
              </div>
              <div class="self-stretch flex flex-col justify-start items-start gap-4">
                <div class="self-stretch inline-flex justify-start items-center gap-6">
                  <div data-style="Collapse" class="py-2 rounded-md flex justify-start items-center gap-6">
                    <div class="justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Cash Rounding</div>
                  </div>
                  <div data-fill-color="Red" class="w-12 h-6 relative">
                    <div class="w-12 h-6 left-0 top-0 absolute bg-red-500 rounded-[33px]"></div>
                    <div class="w-6 h-5 left-[2px] top-[2px] absolute bg-white rounded-[33px]"></div>
                  </div>
                </div>
                <div class="self-stretch pb-2 flex flex-col justify-start items-start gap-2">
                  <div class="justify-center text-white text-base font-normal font-['Roboto'] leading-5">With cash rounding enabled, your cash payments will be rounded to the nearest .05.</div>
                </div>
              </div>
              <div class="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-700"></div>
              <div class="self-stretch flex flex-col justify-start items-start gap-4">
                <div class="self-stretch inline-flex justify-start items-center gap-6">
                  <div data-style="Collapse" class="py-2 rounded-md flex justify-start items-center gap-6">
                    <div class="justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Community Data Sharing</div>
                  </div>
                  <div data-fill-color="Red" class="w-12 h-6 relative">
                    <div class="w-12 h-6 left-0 top-0 absolute bg-red-500 rounded-[33px]"></div>
                    <div class="w-6 h-5 left-[2px] top-[2px] absolute bg-white rounded-[33px]"></div>
                  </div>
                </div>
                <div class="self-stretch pb-2 inline-flex justify-start items-start gap-2">
                  <div class="flex-1 justify-center text-white text-base font-normal font-['Roboto'] leading-5">Community Sharing is a collaborative feature that lets you team up with retailers we have approved to anonymously share information and boost efficiency. You can take advantage of content that others have added including sharing lot-level THC, CBD and Terps information, which can be a laborious task to input manually.</div>
                </div>
              </div>
            </div>
          </template>
          <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>
        </div>
      </div>
    </div>
  </div>
</template>




<script lang="ts">
  import {
    defineComponent,
    ref
  } from "vue"
  import {
    mapGetters
  } from "vuex";
  import Nav from './Nav.vue';



  export default defineComponent({
    name: "Business Setting",
    components: {
      Nav,
    },



    computed: {
      ...mapGetters({
        vg_selectedLocation: 'location/selected'
      }),
    },

  });
</script>